import i18n from "@/i18n";

export const ACCEPT_LANGUAGE_HEADER = "Accept-Language";

export type AppLocale = "es" | "en";

export const FALLBACK_LOCALE: AppLocale = "es";

const SUPPORTED_LOCALES: readonly AppLocale[] = ["es", "en"];

/** Narrows an i18next language (which may be a region variant, e.g. "en-US") to a supported locale. */
export function toAppLocale(language: string | undefined): AppLocale {
  const supportedLocale = SUPPORTED_LOCALES.find(
    (locale) => locale === language || language?.startsWith(`${locale}-`)
  );

  return supportedLocale ?? FALLBACK_LOCALE;
}

export function getCurrentLocale(): AppLocale {
  return toAppLocale(i18n.resolvedLanguage || i18n.language);
}

/**
 * Builds the Accept-Language header the API uses to localize its responses.
 * The browser's own Accept-Language does not reflect the language the user picked in the admin
 * (i18next persists that to localStorage), so it has to be sent explicitly.
 */
export function buildLocaleHeader(): Record<string, string> {
  return { [ACCEPT_LANGUAGE_HEADER]: getCurrentLocale() };
}

export default buildLocaleHeader;
